import React, { Fragment, Component } from 'react';
import NavLink from './Utils/NavLink';
import { withAuth } from './AuthContext';
import {decode} from 'html-entities';

class LoginNav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            links: [
                {
                    path: '/login',
                    text: decode(props.translated[5]),
                    isActive: false,
                    loggedIn: false,
                    isButton: false
                },
                {
                    path: '/signup',
                    text: decode(props.translated[6]),
                    isActive: false,
                    loggedIn: false,
                    linkClassName: "btn-navigation",
                    isButton: true,
                    btnClassName: "btn-join"
                },
                {
                    path: '/dashboard',
                    text: decode(props.translated[7]),
                    isActive: false,
                    loggedIn: true,
                    isButton: false
                },
                {
                    path: '/dashboard/messages',
                    text: decode(props.translated[8]),
                    isActive: false,
                    loggedIn: true,
                    isButton: false,
                },
                {
                    path: '/logout',
                    text: decode(props.translated[9]),
                    isActive: false,
                    loggedIn: true,
                    isButton: false
                }
            ],
            open: false
        };

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    handleClick(i) {
        const links = this.state.links.slice();
        for (const j in links) {
            links[j].isActive = i == j;
        }
        this.setState({ links: links });
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside(event) {
        const avatar = document.querySelector('.auth-navbar');
        if (avatar && !avatar.contains(event.target)) {
            this.setState({ open: false });
        }
    }

    render() {
        const { loggedIn } = this.props;
        const u = this.props.auth.user;
        const notificationMessages = this.props.auth.notifications.messages;
        const userCompleted = u !== null && u.profilePhotoStatus === 'completed';
        return (
            <Fragment>
                {loggedIn ?
                    <nav className="nav-item auth-navbar">
                        <div className={`dropdown auth-menu ${this.state.open ? 'open' : ''}`}
                            onClick={() => this.setState({ open: !this.state.open })}
                        >
                            {
                                notificationMessages > 0 &&
                                <div className="notification-badge">
                                    {notificationMessages > 9 ? "9+" : notificationMessages}
                                </div>
                            }
                            <div className="avatar-holder">
                                {userCompleted ? (
                                    <img className="img-fluid" src={s3AwsEndpoint+'/'+u.profilePhotoO} onError={(e)=>{e.target.onError = null; e.target.src = "/images/listing/default-profile.png"}}/>
                                ) : (
                                    <img className="img-fluid" src={"/images/listing/default-profile.png"}/>
                                )}
                                <span>
                                    {this.props.translated[10]}
                                </span>
                            </div>
                        </div>

                        {this.state.open && (
                        <ul className="menu-items">
                            {this.state.links
                        .filter(link => link.loggedIn == loggedIn)
                        .map((link, i) => (
                            <NavLink
                                path={link.path}
                                text={link.text}
                                linkClassName={link.linkClassName}
                                isActive={link.isActive}
                                isButton={link.isButton}
                                btnClassName={link.btnClassName}
                                key={link.path}
                                className="menu-item"
                                onClick={() => this.handleClick(i)}
                                notificationMessages={notificationMessages}
                            />
                        ))}
                        </ul>
                        )}
                    </nav>
                :
                    this.state.links
                    .filter(link => link.loggedIn == loggedIn)
                    .map((link, i) => (
                        <NavLink
                            path={link.path}
                            text={link.text}
                            linkClassName={link.linkClassName}
                            isActive={link.isActive}
                            isButton={link.isButton}
                            btnClassName={link.btnClassName}
                            key={link.path}
                            className="dropdown"
                            onClick={() => this.handleClick(i)}
                        />
                    ))
                }
            </Fragment>
        );
    }
}

// Wrap this component in the Auth HOC to access the AuthContext
export default withAuth(LoginNav);
